import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import useTheme from "../../hooks/useTheme";

// components
import Logo from "./Logo";
import MobileNavbar from "./MobileNavbar";

const MobileHeader = () => {
	const { openDrawer, setOpenDrawer } = useTheme();

	return (
		<>
			<div className="px-10 flex justify-between items-center lg:hidden">
				<Logo />
				<GiHamburgerMenu
					className="text-2xl text-green-800 relative right-0"
					onClick={() => setOpenDrawer((prev) => !prev)}
				/>
			</div>
			<MobileNavbar />
		</>
	);
};

export default MobileHeader;
